import { render, staticRenderFns } from "./EModalMatriculasAnteriores.vue?vue&type=template&id=45516178&scoped=true"
import script from "./EModalMatriculasAnteriores.vue?vue&type=script&lang=js"
export * from "./EModalMatriculasAnteriores.vue?vue&type=script&lang=js"
import style0 from "./EModalMatriculasAnteriores.vue?vue&type=style&index=0&id=45516178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45516178",
  null
  
)

export default component.exports